export default __webpack_public_path__ + "static/media/white-cam-2.9e2b8edf.png";